<template>
  <Drawer
    :id="drawerId"
    title="Project Preview"
    width="100%"
  >
    <div
      class="pa-4 h-full w-full"
      v-if="is_open && data"
    >
      <mcs-3d-viewer
        style="display: block; width: 100%; height: 100%"
        :images.prop="data.images"
        :width.prop="data.width"
        :height.prop="data.height"
        :model-url="data.modelUrl"
        :sideNames.prop="data.sideNames"
        :environment-type="data.environmentType"
        :foldAnimation.prop="data.foldAnimation"
      ></mcs-3d-viewer>
    </div>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { DRAWERS } from '@/utils/constants';
import { mapGetters } from 'vuex';
export default {
  name: 'Mcs3dDrawer',
  components: { Drawer },
  data() {
    return { drawerId: DRAWERS.PROJECT_THREED_DRAWER, data: null };
  },
  computed: {
    is_open() {
      return this.drawerId === this.top_drawer?.id;
    },
    ...mapGetters({
      initialData: 'drawers/data',
      top_drawer: 'drawers/topDrawer',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },
  watch: {
    drawerOpenedAt(val, oldVal) {
      if (this.is_open) {
        const initial = this.initialData(this.drawerId) || {};
        this.data = initial;
      }
    }
  }
};
</script>
